export const REQUEST_PODCAST = 'podcast/REQUEST_PODCAST';
export const RECEIVE_PODCAST = 'podcast/RECEIVE_PODCAST';
export const REQUEST_PODCAST_FAILED = 'podcast/REQUEST_PODCAST_FAILED';
